import { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBasket } from '../context/BasketContext.jsx';
import { useStoreUI } from '../context/StoreUIContext.jsx';
import { useToast } from '../context/ToastContext.jsx';
import { closeTebexCheckout, launchTebexCheckout } from '../lib/tebex.js';


export function useCheckout() {
  const { createCheckout, refresh } = useBasket();
  const { openLogin, openBasket, closeBasket } = useStoreUI();
  const { showToast } = useToast();
  const navigate = useNavigate();

  const [isLaunching, setLaunching] = useState(false);
  const failureRef = useRef(null);

  const start = useCallback(
    async () => {
      setLaunching(true);
      failureRef.current = null;

      let orderId = null;

      try {
        await launchTebexCheckout({
          resolveIdent: async () => {
            const result = await createCheckout();

            if (!result.success || !result.ident) {
              if (result.requires_authorization && result.auth_options?.[0]?.url) {
                window.location.assign(result.auth_options[0].url);
              }
              failureRef.current = result;
              throw new Error(result.error || 'Checkout failed.');
            }

            orderId = result.order_id;
            closeBasket();

            return result.ident;
          },

          onComplete: async () => {
            await closeTebexCheckout();
            await refresh();
            navigate(orderId ? `/order/${orderId}` : '/home/');
          },

          onError: () => {
            showToast('Payment failed — please try another method.', 6000, 'error');
          },
        });
      } catch {
        const failure = failureRef.current;

        if (failure?.requires_login) {
          openLogin();
        } else if (failure?.requires_authorization) {
          showToast('Continue through Tebex to authenticate your Minecraft account.', 6000);
        } else if (failure?.basket_changed) {

          await refresh();
          openBasket();
          showToast(failure.error, 9000, 'error');
        } else {
          showToast(failure?.error || 'Could not open checkout.', 6000, 'error');
        }
      } finally {
        setLaunching(false);
      }
    },
    [
      createCheckout,
      refresh,
      navigate,
      showToast,
      openLogin,
      openBasket,
      closeBasket,
    ],
  );

  return { start, isLaunching };
}
